<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <UsersubTableMenu @methodEnum='methodEnum'></UsersubTableMenu>
      <UsersubTable ref="usersubTable"></UsersubTable>
    </template>
  </BasicLayout>
</template>

<script>
import UsersubTable from '../../../../components/subscriberconfig/udmSubscriber/usersub/UsersubTable';
import UsersubTableMenu from '../../../../components/subscriberconfig/udmSubscriber/usersub/UsersubTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'UsersubMainPage',
  components: {
    NeList,
    UsersubTable,
    UsersubTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("Profile.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("Usersub.crumb"),
      },
      netype: [36],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.usersubTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.usersubTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.usersubTable.delProfiles();
          break;
        case 'qry':
          this.$refs.usersubTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.usersubTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
